module.exports = __webpack_public_path__ + "static/media/ic-no-access-large.9c4c381c.svg";